import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";

// Everything but the public verification page loads on demand, so verifiers
// never download the admin portal (or Recharts).
const JoinRequest = lazy(() => import("@/pages/join/page"));
const AdminLogin = lazy(() => import("@/pages/admin/login/page"));
const AdminLayout = lazy(() => import("@/pages/admin/components/AdminLayout"));
const Dashboard = lazy(() => import("@/pages/admin/dashboard/page"));
const ConnectionRequests = lazy(() => import("@/pages/admin/connection-requests/page"));
const Institutions = lazy(() => import("@/pages/admin/institutions/page"));
const InstitutionDetail = lazy(() => import("@/pages/admin/institutions/detail/page"));
const Verifications = lazy(() => import("@/pages/admin/verifications/page"));
const Analytics = lazy(() => import("@/pages/admin/analytics/page"));
const SystemActivity = lazy(() => import("@/pages/admin/system-activity/page"));
const Settings = lazy(() => import("@/pages/admin/settings/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    // The pre-filled link universities hand out, e.g. ?institution=…&method=result&reference=…
    path: "/verify",
    element: <Home />,
  },
  {
    path: "/join",
    element: <JoinRequest />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: "connection-requests", element: <ConnectionRequests /> },
      { path: "institutions", element: <Institutions /> },
      { path: "institutions/:id", element: <InstitutionDetail /> },
      { path: "verifications", element: <Verifications /> },
      { path: "analytics", element: <Analytics /> },
      { path: "system-activity", element: <SystemActivity /> },
      { path: "settings", element: <Settings /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
